import type { FaireProductEntity } from "../../entity_types/product";

export const p_hjm3crxw2p: FaireProductEntity = {
  token: "p_hjm3crxw2p",
  type: "product",
  name: "Self Love Tealight Spell Candles",
  brandToken: "b_ud3dmwvnmf",
  brandName: "You Are Uniquely Magic",
  imageUrl:
    "https://cdn.faire.com/fastly/cfbc7842b6742b407d4380a67102f70e0e3213377306a208e092eb7c77c82d0d.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/bdcdb851ffb1b983901200d202be40568208d2f29b9e60a8ec104d1687e2b603.jpeg",
    "https://cdn.faire.com/fastly/defaf682c929d175e59ea16b64db4e0c183e65c41e7404ac7af4816149df029a.jpeg",
    "https://cdn.faire.com/fastly/ba5483312151cc878dee03ef368090cee42078cf0344fc7243c2c257512ae470.jpeg",
    "https://cdn.faire.com/fastly/946c46dc643dd5dad63e14f7834ed7bc0d92e25c2fd989ac34946521f65e542a.jpeg",
    "https://cdn.faire.com/fastly/344b5f6ee346a21a5b9285b92f42d9923024b1d51dec1adebd1efb7a52acbb9b.jpeg",
    "https://cdn.faire.com/fastly/996096532a5b4716d6d1f5a61bca5c72e24c49aca9dac909436ed8ca6b0ab03d.jpeg",
    "https://cdn.faire.com/fastly/de93d4fd569d842abd1609645106d29b37ca72009413ad01e356bbbeb62bc05b.jpeg",
    "https://cdn.faire.com/fastly/a978b095ecb6aa68a6700efa56ec3d7d56f156c5ca55fe36cb7dc9d5f7cc59db.jpeg",
  ],
  priceDollars: 1,
  description:
    "Self Love Tealight Spell Candles 10 Pack\n\nListing is for 10 Self Love Tealight Spell Candles. Vanilla Bean/light Rose scent. Each tealight spell candles may vary slightly in appearance because each is hand dressed by me.\n\nEach spell candle is filled with herbs, flowers, anointing oil, crystals and all my intentions.\n\nHold and focus on your intentions. Think about all the things that make you special, beautiful and unique. Think about what you love most about yourself. Imagine a bubble of energy surrounding you and protecting you from negative energies and outside influences. Intention and manifestation are everything.\n\nSpell candles can be used in rituals, spells, or just filled with your intentions and burned.\n\n*Please supervise all open flames! Never leave unattended!*",
  tags: [],
  msrpDollars: 2,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-08-15T03:47:45.086Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
